// extracted by mini-css-extract-plugin
export default {"container":"optimizeTesting_container__YRnFA","toolBar":"optimizeTesting_toolBar__Y+Rc-","box":"optimizeTesting_box__IazZJ"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"optimizeTesting_container__YRnFA\",\"toolBar\":\"optimizeTesting_toolBar__Y+Rc-\",\"box\":\"optimizeTesting_box__IazZJ\"}";
        // 1793760839032
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  